import http from '@/services/http.js';

/**
 * 获取所有视频类型
 * @returns {Promise<Array>} 视频类型列表
 */
export const getVideoTypes = async () => {
  try {
    const response = await http.get('/videoapi/video-types/list?isActive=true');
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error('Failed to fetch video types');
  } catch (error) {
    console.error('Error fetching video types:', error);
    throw error;
  }
};

export const fetchVideoTypeList = async () => {
  const response = await http.get('/videoapi/video-types/list');
  return response;
};

export const createVideoType = async (payload) => {
  const response = await http.post('/videoapi/video-types', payload);
  return response;
};

export const updateVideoType = async (id, payload) => {
  const response = await http.put(`/videoapi/video-types/${id}`, payload);
  return response;
};

export const deleteVideoType = async (id) => {
  const response = await http.delete(`/videoapi/video-types/${id}`);
  return response;
};
